import React from 'react';
import { ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const SearchForm = ({ dropdowns, form, onFormUpdate }) => (
  <Panel defaultExpanded>
    <Panel.Toggle componentClass={Panel.Heading}>
      <Panel.Title>
        <FontAwesome name="search" /> Search Purchase Orders
      </Panel.Title>
    </Panel.Toggle>
    <Panel.Collapse>
      <Panel.Body>
        <FormGroup>
          <ControlLabel>Name/PO Number</ControlLabel>
          <FormControl onChange={(e) => onFormUpdate({ query: e.target.value })} value={form.query || ''} />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Status</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.purchaseOrderStatuses}
            placeholder="All"
            value={form.statuses}
            valueKey="id"
            onChange={(e) => onFormUpdate({ statuses: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Office</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.offices}
            placeholder="All"
            value={form.offices}
            valueKey="id"
            onChange={(e) => onFormUpdate({ offices: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Supplier</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.suppliers}
            placeholder="All"
            value={form.suppliers}
            valueKey="id"
            onChange={(e) => onFormUpdate({ suppliers: e })}
          />
        </FormGroup>
      </Panel.Body>
    </Panel.Collapse>
  </Panel>
);

export default SearchForm;
